import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { jobData } from "../../StaticData/aboutus";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../Careers/Careers.css";
import { motion } from "framer-motion";

const JobListing = () => {
  // const [filters, setFilters] = useState({
  //   designation: "",
  //   location: "",
  //   experience: "",
  // });
  const [filteredJobs, setFilteredJobs] = useState(jobData);
  // const [designationSuggestions, setDesignationSuggestions] = useState([]);
  // const [locationSuggestions, setLocationSuggestions] = useState([]);

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFilters({ ...filters, [name]: value });

  //   if (name === "designation") {
  //     const suggestions = jobData
  //       .map((job) => job.job_role)
  //       .filter((role) =>
  //         role.toLowerCase().includes(value.toLowerCase())
  //       );
  //     setDesignationSuggestions(suggestions.slice(0, 5)); // Limit to 5 suggestions
  //   }

  //   if (name === "location") {
  //     const suggestions = jobData
  //       .map((job) => job.location)
  //       .filter((loc) =>
  //         loc.toLowerCase().includes(value.toLowerCase())
  //       );
  //     setLocationSuggestions(suggestions.slice(0, 5)); // Limit to 5 suggestions
  //   }
  // };

  // const handleFilterSubmit = () => {
  //   const filtered = jobData.filter((job) => {
  //     const matchesDesignation = filters.designation
  //       ? job.job_role.toLowerCase().includes(filters.designation.toLowerCase())
  //       : true;
  //     const matchesLocation = filters.location
  //       ? job.location.toLowerCase().includes(filters.location.toLowerCase())
  //       : true;
  //     return matchesDesignation && matchesLocation;
  //   });
  //   setFilteredJobs(filtered);
  // };

  // const handleSuggestionClick = (name, value) => {
  //   setFilters({ ...filters, [name]: value });
  //   if (name === "designation") setDesignationSuggestions([]);
  //   if (name === "location") setLocationSuggestions([]);
  // };

  return (
    <div>
      <Helmet>
        <title> Featured Jobs | Idexcel </title>
        <meta
          content="current openings usa, current openings india"
          name="keywords"
        />
        <meta
          content="Ready to explore a career with Idexcel? Click here and explore our job openings."
          name="description"
        />
      </Helmet>
      <motion.div
        className="Productright"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <Container fluid className="careers-inner-banner-container p-0">
          <section className="careers-inner-banner-section">
            {/* <Row>
            <Col lg={12}>
              <div className="banner-overlay px-2 pt-5">
                <div>
                  <Row>
                    <Col md={3} className="mb-2 position-relative">
                      <input
                        type="text"
                        name="designation"
                        placeholder="Enter designation"
                        className="form-control mr-3"
                        value={filters.designation}
                        onChange={handleInputChange}
                        onBlur={() => setTimeout(() => setLocationSuggestions([]), 200)} 
                      />
                      {designationSuggestions.length > 0 && (
                        <ul className="suggestions-list">
                          {designationSuggestions.map((suggestion, index) => (
                            <li
                              key={index}
                              onClick={() =>
                                handleSuggestionClick("designation", suggestion)
                              }
                            >
                              {suggestion}
                            </li>
                          ))}
                        </ul>
                      )}
                    </Col>
                    <Col md={3} className="mb-2 position-relative">
                      <input
                        type="text"
                        name="location"
                        placeholder="Enter location"
                        className="form-control mr-3"
                        value={filters.location}
                        onChange={handleInputChange}
                      />
                      {locationSuggestions.length > 0 && (
                        <ul className="suggestions-list">
                          {locationSuggestions.map((suggestion, index) => (
                            <li
                              key={index}
                              onClick={() =>
                                handleSuggestionClick("location", suggestion)
                              }
                            >
                              {suggestion}
                            </li>
                          ))}
                        </ul>
                      )}
                    </Col>
                    <Col md={3} className="mb-2">
                      <select
                        name="experience"
                        className="form-control mr-3"
                        value={filters.experience}
                        onChange={handleInputChange}
                      >
                        <option value="">Experience</option>
                        {[...Array(21).keys()].map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </Col>
                    <Col md={3} className="d-flex align-items-end mb-2">
                      <button
                        className="btn btn-danger"
                        type="button"
                        onClick={handleFilterSubmit}
                      >
                        Submit
                      </button>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row> */}
          </section>
        </Container>
      </motion.div>
      <section>
        <Container className="my-5 px-xl-5">
          <div className="job-listing-page d-flex justify-content-xl-between flex-column flex-xl-row">
            <div
              className="left-col d-flex flex-column"
            >
              <h2 className="text-center mb-1 section-title align-self-start">
                Featured <span className="textgrad"> Jobs </span>
              </h2>
              <hr />
              <div className="right-col mt-5">
                {filteredJobs.length > 0 ? (
                  filteredJobs.map((job, index) => (
                    <div key={index} className="job-item mb-4">
                      <Link
                        to={{
                          pathname: job.link,
                          state: { job: job.job_role },
                        }}
                      >
                        <h3 className="textgrad">{job.job_role}</h3>
                      </Link>
                      <p>{job.location}</p>
                    </div>
                  ))
                ) : (
                  <p>No jobs found matching your criteria.</p>
                )}
              </div>
            </div>
            <div className="right-col">
              <div className="right-col-box d-flex flex-column align-items-center justify-content-center p-4">
                <p className="font-weight-bold">Drop your CV here</p>
                <p>We will consider your Profile for future Jobs</p>
                <a href="/careers/apply-to-job" className="button">
                  Drop CV
                </a>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default JobListing;
